import { ChevronsUpDown, LogOut } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import {
  SidebarFooter,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from '@/components/ui/sidebar';
import { useAuthStore } from '@/auth/useAuthStore';
import { useLogout } from '@/mutations/auth.mutations';
import { GradientIcon } from '@/components/ui/icon-gradient';

export function AppSidebarFooter() {
  const { isMobile } = useSidebar();
  const meInfo = useAuthStore((s) => s.meInfo);
  const { mutate: logout } = useLogout();

  const firstName = meInfo?.firstName ?? '';
  const lastName = meInfo?.lastName ?? '';
  const fullName = [firstName, lastName].filter(Boolean).join(' ') || meInfo?.email || '';
  const userEmail = meInfo?.email ?? '';
  const avatarLetter = (firstName || userEmail).charAt(0).toUpperCase();

  return (
    <SidebarFooter className="p-3">
      <SidebarMenu>
        <SidebarMenuItem>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <SidebarMenuButton
                size="lg"
                className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground rounded-xl"
              >
                <GradientIcon
                  variant={avatarLetter}
                  className="size-8 rounded-full shrink-0"
                />
                <div className="flex-1 min-w-0 text-left">
                  <p className="text-sm font-medium truncate leading-tight">{fullName}</p>
                  <p className="text-xs text-sidebar-foreground/60 truncate">{userEmail}</p>
                </div>
                <ChevronsUpDown className="size-4 shrink-0 text-sidebar-foreground/40" />
              </SidebarMenuButton>
            </DropdownMenuTrigger>

            <DropdownMenuContent
              className="w-(--radix-dropdown-menu-trigger-width) min-w-56 rounded-xl p-1 bg-sidebar border-sidebar-border shadow-lg"
              side={isMobile ? 'bottom' : 'right'}
              align="end"
              sideOffset={8}
            >
              <div className="flex items-center gap-3 px-3 py-2.5">
                <GradientIcon
                  variant={avatarLetter}
                  className="size-9 rounded-full shrink-0"
                />
                <div className="min-w-0">
                  <p className="text-sm font-semibold truncate leading-tight">{fullName}</p>
                  <p className="text-xs text-muted-foreground truncate">{userEmail}</p>
                </div>
              </div>

              <DropdownMenuSeparator className="my-1" />

              <DropdownMenuItem
                className="flex items-center gap-2 cursor-pointer rounded-lg text-destructive focus:text-destructive focus:bg-destructive/10"
                onClick={() => logout()}
              >
                <LogOut className="size-4" />
                Sign out
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </SidebarMenuItem>
      </SidebarMenu>
    </SidebarFooter>
  );
}
